import { Card, CardFooter, FadeContent, FadeWrapper } from 'components/common';
import CustomScrollbar from 'components/common/CustomScrollbar';
import { CommonLink } from 'components/common/Forms/Button';
import { CardLoader } from 'components/common/Loading';
import { ReadOnlyQuill } from 'components/WYSIWYG/ReadOnlyQuill';
import { QuillPreview } from 'components/WYSIWYG/WYSIWYG.styled';
import { PatientLayout } from 'containers/PatientLayout';
import { useAuth } from 'context/AuthContext';
import { useGDPRTemplate } from 'query/storage';
import { useCommonTranslation } from 'hooks/i18n/useCommonTranslation';
import { PageHelmet } from 'components/common/PageHelmet';
import { LegalPolicyTabs } from './LegalPolicyTabs';

export const PrivacyPolicyPage = () => {
  const { sangixUser } = useAuth();
  const { t } = useCommonTranslation();

  const { isLoading, data } = useGDPRTemplate();
  const content = data?.data;

  return (
    <PatientLayout graphics={Boolean(sangixUser) ? 'patient' : 'unauth'}>
      <PageHelmet title={t('privacy-policy')} />
      <Card fade>
        <FadeWrapper>
          <CustomScrollbar
            style={{ width: '100%' }}
            autoHeight
            autoHeightMin={'100%'}
            autoHeightMax={'100%'}
          >
            <FadeContent>
              <LegalPolicyTabs />
              {isLoading && !Boolean(content) ? (
                <CardLoader />
              ) : (
                <QuillPreview>
                  <ReadOnlyQuill value={content as string} />
                </QuillPreview>
              )}
            </FadeContent>
          </CustomScrollbar>
        </FadeWrapper>
        <CardFooter>
          <CommonLink to="/" variant="secondary">
            {t('back-to-menu')}
          </CommonLink>
        </CardFooter>
      </Card>
    </PatientLayout>
  );
};
